import { createReducer } from "redux-create-reducer";
import { GET_ORGANIZATIONS, ORGANIZATION_AUTHENTICATION } from "../types";
const initialState = {
  data: [],
  matchedOrganizations: [],
  isLoading: false,
};
const organizationsReducer = createReducer(initialState, {
  [GET_ORGANIZATIONS.FULFILLED]: (state, { payload }) => ({
    data: payload.data,
  }),
  [ORGANIZATION_AUTHENTICATION.DEFAULT]: (state) => ({
    ...state,
    isCompleted: false,
    isLoading: true,
  }),
  [ORGANIZATION_AUTHENTICATION.PENDING]: (state) => ({
    ...state,
    isCompleted: false,
    isLoading: true,
  }),
  [ORGANIZATION_AUTHENTICATION.REJECTED]: (state) => ({
    ...state,
    isCompleted: false,
    isLoading: false,
  }),
  [ORGANIZATION_AUTHENTICATION.FULFILLED]: (state, { payload }) => ({
    ...state,
    matchedOrganizations: payload.data.matchedOrganizations,
    isLoading: false,
    isCompleted: true,
  }),
});
export default organizationsReducer;



// WEBPACK FOOTER //
// ./src/reducers/organizationsReducer.js